const isTestDriveEnabledState = ({state = "", userState = "", isTestDriveEnabledForIndiaFlag, eligibleStateNames = []}) => {
    return ((eligibleStateNames || []).includes(state) && state === userState) || isTestDriveEnabledForIndiaFlag;
};

export default isTestDriveEnabledState;
